import { Host, h, getAssetPath } from "@stencil/core";
export class GxgPaginator {
    constructor() {
        this.alignment = "center";
    }
    el;
    componentWillLoad() {
        const iconsUrl = getAssetPath("./icon-assets/");
        this.el.style.setProperty("--navigateFirstUrl", `url("${iconsUrl}navigation/arrow-left.svg")`);
        this.el.style.setProperty("--navigatePrevUrl", `url("${iconsUrl}navigation/chevron-left.svg")`);
        this.el.style.setProperty("--navigateLastUrl", `url("${iconsUrl}navigation/arrow-right.svg")`);
        this.el.style.setProperty("--navigateNextUrl", `url("${iconsUrl}navigation/chevron-right.svg")`);
    }
    render() {
        return (h(Host, null, h("slot", null)));
    }
    static get is() { return "gxg-paginator"; }
    static get originalStyleUrls() {
        return {
            "$": ["gxg-paginator.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["gxg-paginator.css"]
        };
    }
    static get properties() {
        return {
            "alignment": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "PaginatorAlignment",
                    "resolved": "\"center\" | \"end\" | \"start\"",
                    "references": {
                        "PaginatorAlignment": {
                            "location": "local",
                            "path": "/home/circleci/repo/src/components/paginator/gxg-paginator.tsx",
                            "id": "src/components/paginator/gxg-paginator.tsx::PaginatorAlignment"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The paginator alignment:"
                },
                "attribute": "alignment",
                "reflect": true,
                "defaultValue": "\"center\""
            }
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=gxg-paginator.js.map
